import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	taskOneDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.alerts-step.task-one-description-non-final',
		defaultMessage: `
We've completely redesigned alerts to look and work like the way you'd like, so they're just as familiar as everything else on Jira.\n
Now, Jira's robust design language powers the alert's layout, structure, actions, and details, making it more intuitive for you to work with alerts.\n
Take a look at it yourself by viewing your alerts.
        `,
		description: 'Transition home alerts step task one description',
	},
	taskOneButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.alerts-step.task-one-button-non-final',
		defaultMessage: 'View your alerts',
		description: 'Transition home alerts step task one button',
	},
	taskTwoDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.alerts-step.task-two-description-non-final',
		defaultMessage: `
To view your alerts, select **Your work** from Jira navigation and select **Alerts.**
You can also access your alerts from the **Alerts widget** on the **Your work** page.\n
Want to create alerts yourself? Select **Create alert** from **More actions** on the **Alerts** page.
        `,
		description: 'Transition home alerts step task two description',
	},
	taskThreeDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.alerts-step.task-three-description-non-final',
		defaultMessage:
			"While it's possible for you to work on your alerts on Opsgenie, it will support only critical actions. All of your alert, on-call, and incident response data from Opsgenie are now natively available on Jira Service Management, so you won't have to log in to Opsgenie.",
		description: 'Transition home alerts step task three description',
	},
	taskFourDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.alerts-step.task-four-description-non-final',
		defaultMessage: `
You can check your current on-call status and schedule times from the **On-call schedules** widget on the **Your work page**. Select **View all** to get a view of your on-call times and browse all the schedules.
        `,
		description: 'Transition home alerts step task four description',
	},
	taskFourButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.alerts-step.task-four-button-non-final',
		defaultMessage: 'View your on-call schedules',
		description: 'Transition home alerts step task four button',
	},
});
